// Plafonds de ressources de l'ANAH applicables à MaPrimeAdapt', barème au
// 1er janvier 2026, pour l'Île-de-France — la seule zone que nous couvrons.
//
// Source : service-public.gouv.fr, fiche F37501 « MaPrimeAdapt' : travaux
// d'adaptation du logement à la perte d'autonomie ».
// https://www.service-public.gouv.fr/particuliers/vosdroits/F37501
//
// Le revenu pris en compte est le revenu fiscal de référence (RFR) de
// l'année N-1, celui qui figure sur le dernier avis d'imposition, cumulé pour
// toutes les personnes qui occupent le logement.
//
// Ces valeurs sont la source unique du site : simulateur, page dédiée et
// contenus éditoriaux les lisent ici, pour qu'un changement de barème ne
// laisse jamais un chiffre périmé quelque part.

export const ANNEE_BAREME = 2026;

export const SOURCE_BAREME = {
  libelle: "service-public.gouv.fr — fiche MaPrimeAdapt' (F37501)",
  url: "https://www.service-public.gouv.fr/particuliers/vosdroits/F37501",
};

// Plafonds de revenu fiscal de référence, en euros, par nombre de personnes
// composant le ménage.
export const PLAFONDS_IDF = {
  tresModestes: { 1: 24031, 2: 35270, 3: 42357, 4: 49455, 5: 56580, parPersonneSup: 7116 },
  modestes: { 1: 29253, 2: 42933, 3: 51564, 4: 60208, 5: 68877, parPersonneSup: 8663 },
};

// Taux de prise en charge et plafond de travaux.
// Rappel de conformité : 22 000 € est un plafond de TRAVAUX HT, pas un montant
// d'aide. L'aide maximale vaut 15 400 € à 70 % et 11 000 € à 50 %.
export const TAUX = {
  tresModestes: 0.7,
  modestes: 0.5,
};
export const PLAFOND_TRAVAUX = 22000;
export const AIDE_MAX = {
  tresModestes: PLAFOND_TRAVAUX * TAUX.tresModestes, // 15 400 €
  modestes: PLAFOND_TRAVAUX * TAUX.modestes, // 11 000 €
};

/** Plafond applicable à un ménage de `n` personnes, au-delà de 5 compris. */
export const plafond = (categorie, n) => {
  const bareme = PLAFONDS_IDF[categorie];
  if (!bareme) return null;
  if (n <= 5) return bareme[n];
  return bareme[5] + (n - 5) * bareme.parPersonneSup;
};

/** « 24 031 € » — espace insécable fine avant l'unité, comme le reste du site. */
export const formaterEuros = (montant) =>
  `${montant.toLocaleString("fr-FR").replace(/ | /g, " ")} €`;

/** Catégorie de ressources d'un ménage, ou null si au-delà des plafonds. */
export const categoriePour = (rfr, nbPersonnes) => {
  if (rfr <= plafond("tresModestes", nbPersonnes)) return "tresModestes";
  if (rfr <= plafond("modestes", nbPersonnes)) return "modestes";
  return null;
};

/** Lignes du tableau public, de 1 à 5 personnes. */
export const lignesBareme = () =>
  [1, 2, 3, 4, 5].map((n) => ({
    personnes: n,
    tresModestes: plafond("tresModestes", n),
    modestes: plafond("modestes", n),
  }));
